const getDefaultForm = () => ({
  serieFactura: '',
  numFactura: '',
  dateEmision: '',
  albaran: '',
  pedido: '',
  observaciones: '',
  numExpediente: '',
  dateExpediente: '',
  numEmisor: '',
  dateEmisor: '',
  codAsignacion: '',
  dateReceptor: '',
  dir3: '',
  numContrato: '',
  codDepReceptor: '',
  periodoDesde: '',
  periodoHasta: '',
  tipoImpuestoFactura: 0
})
const getDefaultState = () => {
  return {
    form: getDefaultForm()
  }
}
  
const state = getDefaultState()
const getters = { form: state => state.form }
const mutations = {}
const actions = {
  resetForm ({ state }) {
    state.form = getDefaultForm()
  }
}
  
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
